import { vendorsApi } from '../api/modules/vendors.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { vendorMasterSeed } from '../data/master/vendors';
import { mapPaginated, vendorFromApi, vendorToApi } from '../models';

export async function listVendors(params = {}) {
  if (!USE_API) {
    let items = [...vendorMasterSeed];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (v) =>
          v.tradeAgencyName?.toLowerCase().includes(q) ||
          v.vendorId?.toLowerCase().includes(q) ||
          v.mobile?.includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await vendorsApi.list(params);
    return mapPaginated(result, vendorFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load vendors'));
  }
}

export async function getVendor(id) {
  if (!USE_API) {
    return vendorMasterSeed.find((v) => v.vendorId === id) || null;
  }
  try {
    return vendorFromApi(await vendorsApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load vendor'));
  }
}

export async function createVendor(ui) {
  if (!USE_API) throw new Error('Create vendor requires API mode');
  try {
    return vendorFromApi(await vendorsApi.create(vendorToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create vendor'));
  }
}

export async function updateVendor(id, ui) {
  if (!USE_API) throw new Error('Update vendor requires API mode');
  try {
    return vendorFromApi(await vendorsApi.update(id, vendorToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update vendor'));
  }
}

export async function verifyVendor(id, body) {
  if (!USE_API) throw new Error('Verify vendor requires API mode');
  try {
    const data = await vendorsApi.verify(id, body);
    const vendorRow = data?.vendor ?? data;
    return {
      ...vendorFromApi(vendorRow),
      portalToken: data?.portalToken || vendorRow?.portalToken || '',
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to verify vendor'));
  }
}

export async function regenerateVendorPortalToken(id) {
  if (!USE_API) throw new Error('Portal token requires API mode');
  try {
    const data = await vendorsApi.regeneratePortalToken(id);
    const vendorRow = data?.vendor ?? data;
    return {
      ...vendorFromApi(vendorRow),
      portalToken: data?.portalToken || '',
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to generate portal link'));
  }
}

export async function blockVendor(id, body) {
  if (!USE_API) throw new Error('Block vendor requires API mode');
  try {
    return vendorFromApi(await vendorsApi.block(id, body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to block vendor'));
  }
}

export async function deleteVendor(id) {
  if (!USE_API) throw new Error('Delete vendor requires API mode');
  try {
    await vendorsApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete vendor'));
  }
}
